import { MOVE_TEMPORARY_ITEM, CLEAR_NEXT_QUIZ_ENTRY, CLEAR_TEMPORARY_ITEM, CLEAR_TEMPORARY_BANK_ITEM, CLEAR_TEMPORARY_STIMULUS, CREATE_TEMPORARY_ITEM, CREATE_TEMPORARY_BANK_ITEM, CREATE_TEMPORARY_BANK, CREATE_TEMPORARY_STIMULUS, QUIZ_MODIFICATION, BANK_MODIFICATION, QUIZ_ENTRIES_MODIFICATION, QUIZ_SESSION_RESULT_MODIFICATION, ITEM_MODIFICATION, CLEAR_MODIFICATIONS, SESSION_ITEM_RESULTS_MODIFICATION, SET_NEXT_QUIZ_ENTRY, STIMULUS_MODIFICATION } from '@instructure/quiz-common';

// =====================================================
// =====================================================

// These actions change 'modifications' in state, which
// are meant to represent any non-persisted alterations
// to state.

// example: when changing a editing a quiz. If you change
// the title, a modification is saved to state, until that
// modification is persisted, the "workingQuiz" will be
// the persisted quiz state (found in state.get('quizzes'))
// merged with these modifications.

// =====================================================
// =====================================================

// ==================
// ==================
//      QUIZZES
// ==================
// ==================

export function changeQuizTitle(quizId, newTitle) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        title: newTitle
      }
    }
  };
}
export function changeQuizInstructions(quizId, newInstructions) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        instructions: newInstructions
      }
    }
  };
}
export function changeQuizAllowClearMCSelection(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        allowClearMcSelection: Boolean(value)
      }
    }
  };
}
export function changeQuizChoiceElimination(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        choiceElimination: Boolean(value)
      }
    }
  };
}
export function changeQuizDefaultRceSettings(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        defaultRceSettings: value
      }
    }
  };
}
export function changeQuizShuffleQuestions(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        shuffleQuestions: Boolean(value)
      }
    }
  };
}
export function changeQuizShuffleAnswers(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        shuffleAnswers: Boolean(value)
      }
    }
  };
}
export function changeQuizDisableDocumentAccess(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        disableDocumentAccess: Boolean(value)
      }
    }
  };
}
export function changeQuizRequireStudentAccessCode(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        requireStudentAccessCode: Boolean(value)
      }
    }
  };
}
export function changeQuizStudentAccessCode(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        studentAccessCode: value
      }
    }
  };
}
export function changeQuizHasTimeLimit(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        hasTimeLimit: Boolean(value)
      }
    }
  };
}
export function changeSessionTimeLimitInSeconds(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        sessionTimeLimitInSeconds: value
      }
    }
  };
}
export function changeQuizOutcomeAlignmentSetGuid(quizId, newGuid) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        outcomeAlignmentSetGuid: newGuid
      }
    }
  };
}
export function changeQuizAllowBacktracking(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        allowBacktracking: value
      }
    }
  };
}
export function changeQuizOneAtATimeType(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        oneAtATimeType: value
      }
    }
  };
}
export function changeQuizCalculatorType(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        calculatorType: value
      }
    }
  };
}
export function changeResultsFeedback(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        resultsFeedback: value
      }
    }
  };
}
export function changeResultsFeedbackEnabled(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        resultsFeedbackEnabled: value
      }
    }
  };
}
export function changeQuizDetectMultipleSessions(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        detectMultipleSessions: Boolean(value)
      }
    }
  };
}

// ==================
// ==================
//       ITEMS
// ==================
// ==================

export function changeItemTitle(itemId, newTitle) {
  return {
    type: ITEM_MODIFICATION,
    payload: {
      id: itemId,
      modifications: {
        title: newTitle
      }
    }
  };
}
export function changeItemBody(itemId, newInstructions) {
  return {
    type: ITEM_MODIFICATION,
    payload: {
      id: itemId,
      modifications: {
        itemBody: newInstructions
      }
    }
  };
}
export function changeItemState(itemId, modifications) {
  return {
    type: ITEM_MODIFICATION,
    payload: {
      id: itemId,
      modifications: modifications
    }
  };
}
export function changeItemFeedback(itemId, newFeedback) {
  return {
    type: ITEM_MODIFICATION,
    payload: {
      id: itemId,
      modifications: {
        feedback: newFeedback
      }
    }
  };
}
export function changeOutcomeAlignmentSetGuid(itemId, newGuid) {
  return {
    type: ITEM_MODIFICATION,
    payload: {
      id: itemId,
      modifications: {
        outcomeAlignmentSetGuid: newGuid
      }
    }
  };
}

// =====================
// =====================
//     QUIZZES ITEMS
// =====================
// =====================

export function setNextQuizEntry(interactionTypeData, quizId, position, stimulusId, parentEntryId) {
  return {
    type: SET_NEXT_QUIZ_ENTRY,
    payload: {
      interactionTypeData: interactionTypeData,
      quizId: quizId,
      position: position,
      stimulusId: stimulusId,
      parentEntryId: parentEntryId
    }
  };
}
export function clearNextQuizEntry() {
  return {
    type: CLEAR_NEXT_QUIZ_ENTRY,
    payload: {}
  };
}
export function changeQuizEntryPoints(quizEntryId, newPoints) {
  var newQuizEntryRegrades = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return {
    type: QUIZ_ENTRIES_MODIFICATION,
    payload: {
      id: quizEntryId,
      modifications: {
        pointsPossible: newPoints,
        regradeAdjustedPointsPossible: null,
        quizEntryRegrades: newQuizEntryRegrades
      }
    }
  };
}
export function changeQuizEntryProperties(quizEntryId, properties) {
  return {
    type: QUIZ_ENTRIES_MODIFICATION,
    payload: {
      id: quizEntryId,
      modifications: {
        properties: properties
      }
    }
  };
}
export function changeQuizEntryEntry(quizEntryId, entryId) {
  var entryType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var modifications = {
    entry: {
      id: entryId
    }
  };
  if (entryType) {
    modifications.entryType = entryType;
  }
  return {
    type: QUIZ_ENTRIES_MODIFICATION,
    payload: {
      id: quizEntryId,
      modifications: modifications
    }
  };
}
export function createItem(quizId, position, interactionTypeData) {
  var parentEntryId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var stimulusId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var pointsPossible = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return function (dispatch, getState) {
    dispatch({
      type: CREATE_TEMPORARY_ITEM,
      payload: {
        quizId: quizId,
        parentEntryId: parentEntryId,
        pointsPossible: pointsPossible,
        position: position,
        interactionTypeData: interactionTypeData,
        stimulusId: stimulusId
      }
    });
  };
}

// dont make this a needed arg
export function clearTemporaryItem(quizId) {
  return function (dispatch, getState) {
    dispatch({
      type: CLEAR_TEMPORARY_ITEM,
      payload: {
        quizId: quizId
      }
    });
  };
}
export function moveTemporaryQuizEntry(directionOrPosition, stimulusQuizEntryId, movingDown) {
  var payload = directionOrPosition === 'up' || directionOrPosition === 'down' ? {
    direction: directionOrPosition
  } : {
    position: directionOrPosition
  };
  payload.stimulusQuizEntryId = stimulusQuizEntryId;
  payload.movingDown = movingDown;
  return {
    type: MOVE_TEMPORARY_ITEM,
    payload: payload
  };
}

// =====================
// =====================
//  QUIZ SESSION RESULTS
// =====================
// =====================

export function changeFudgePoints(quizSessionResultId, fudgePoints) {
  return {
    type: QUIZ_SESSION_RESULT_MODIFICATION,
    payload: {
      id: quizSessionResultId,
      modifications: {
        fudgePoints: fudgePoints
      }
    }
  };
}

// =====================
// =====================
//  SESSION ITEM RESULTS
// =====================
// =====================

export function sessionItemResultsModification(sessionItemResultKey, modifications) {
  return {
    type: SESSION_ITEM_RESULTS_MODIFICATION,
    payload: {
      id: sessionItemResultKey,
      modifications: modifications
    }
  };
}

// =====================
// =====================
//  BANKS
// =====================
// =====================

export function createBank() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? null : _ref$language;
  return function (dispatch, getState) {
    dispatch({
      type: CREATE_TEMPORARY_BANK,
      payload: {
        language: language
      }
    });
  };
}

// modifications = { name: 'Current Name' }
export function changeBank(bankId, modifications) {
  return {
    type: BANK_MODIFICATION,
    payload: {
      id: bankId,
      modifications: modifications
    }
  };
}
export function createBankItem(bankId, bankEntryType, interactionTypeData) {
  return function (dispatch, getState) {
    dispatch({
      type: CREATE_TEMPORARY_BANK_ITEM,
      payload: {
        bankId: bankId,
        interactionTypeData: interactionTypeData,
        bankEntryType: bankEntryType
      }
    });
  };
}
export function clearTemporaryBankItem(bankId) {
  return function (dispatch, getState) {
    dispatch({
      type: CLEAR_TEMPORARY_BANK_ITEM,
      payload: {
        bankId: bankId
      }
    });
  };
}

// =====================
// =====================
//  STIMULI
// =====================
// =====================

export function createStimulus(quizId, position, isPassage) {
  return function (dispatch, getState) {
    dispatch({
      type: CREATE_TEMPORARY_STIMULUS,
      payload: {
        quizId: quizId,
        position: position,
        isPassage: isPassage
      }
    });
  };
}
export function modifyStimulus(stimulus) {
  return function (dispatch, getState) {
    dispatch({
      type: STIMULUS_MODIFICATION,
      payload: {
        stimulus: stimulus
      }
    });
  };
}
export function clearTemporaryStimulus(quizId) {
  return function (dispatch, getState) {
    dispatch({
      type: CLEAR_TEMPORARY_STIMULUS,
      payload: {
        quizId: quizId
      }
    });
  };
}

// =====================
// =====================
//     FILTERING
// =====================
// =====================

export function changeQuizFilterIpAddress(quizId, value) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        filterIpAddress: Boolean(value)
      }
    }
  };
}
export function changeQuizIpFilters(quizId, ips, namedIps) {
  return {
    type: QUIZ_MODIFICATION,
    payload: {
      id: quizId,
      modifications: {
        filters: {
          ips: ips,
          namedIps: namedIps
        }
      }
    }
  };
}

// =====================
// =====================
//     CLEAR OBJECTS
// =====================
// =====================

export function clearModifications(objectType, objectId) {
  var deepKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return {
    type: CLEAR_MODIFICATIONS,
    payload: {
      objectType: objectType,
      objectId: objectId,
      deepKeys: deepKeys
    }
  };
}